import { css } from '@emotion/react';
import { Box } from '@mui/material';

import FileIcon from '~/assets/icons/svgs/file-2.svg?react';
import { COLORS } from '~/styles/colors';

export default function PDFPreviewIcon() {
  const styles = useStyles();

  return (
    <Box sx={styles.container}>
      <FileIcon />
    </Box>
  );
}

const useStyles = () => {
  return {
    container: css`
      width: 42px;
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${COLORS.grey400};
      border-radius: 50%;
      flex-shrink: 0;
    `,
  };
};
